var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'header-icon': true,
    rounded: !_vm.label,
    disabled: _vm.disabled,
    'no-icon': !_vm.src,
    'not-interactive': !_vm.onClick,
    'icon-rounded': _vm.iconRounded,
    'not-filled': _vm.notFilled
  },on:{"click":_vm.onClick,"touchstart":e => e.stopPropagation(),"mousedown":e => e.stopPropagation()}},[(_vm.showEditorPin)?_c('div',{staticClass:"header-icon-pin"}):_vm._e(),_vm._v(" "),(_vm.src)?_c('span',{staticClass:"icon",style:({ height: `${_vm.iconSize}px`, width: `${_vm.iconSize}px` })},[_c('img',{style:({ height: `${_vm.iconSize}px`, width: 'auto' }),attrs:{"src":_vm.src}})]):_vm._e(),_vm._v(" "),(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }